module.exports = __webpack_public_path__ + "media/pricing/Profesional_PricingPage-f0e3fd55.png";